import React from 'react';
import Peer2PeerCard from './components/Peer2PeerIndex.jsx';

const Peer2Peer = () => <Peer2PeerCard />;

export default Peer2Peer;
